import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import appConfig from '../../data/config';
import { logout } from './auth-slice';

export const fetchViajanteClientes = createAsyncThunk(
    'viajante/fetchClientes',
    async (search = '', { getState, rejectWithValue }) => {
        const { token } = getState().auth;
        try {
            const url = new URL(`${appConfig.apiUrl}/viajante/clientes`, window.location.href);
            if (search) url.searchParams.set('search', search);

            const res = await fetch(url.toString(), {
                headers: {
                    Accept: 'application/json',
                    Authorization: `Bearer ${token}`,
                },
            });
            const data = await res.json();
            if (!res.ok) return rejectWithValue(data.message || 'Error');
            return data.data;
        } catch {
            return rejectWithValue('Error de conexión.');
        }
    }
);

const viajanteSlice = createSlice({
    name: 'viajante',
    initialState: {
        selectedClient: null,
        clients: [],
        loading: false,
        // Override de forma de venta del pedido en curso. Vive acá y no en el
        // useState de useFormaVentaOverride porque MenuCart (header) y Cart.js
        // (/cart) montan instancias separadas del hook: con estado local, el
        // viajante elegía la forma en la previsualización y al pasar al
        // checkout se volvía a la habitual del cliente en silencio.
        formaVentaOverrideId: null,
    },
    reducers: {
        setSelectedClient(state, action) {
            state.selectedClient = action.payload;
            // El override es por-pedido y por-cliente: cambiar de cliente no
            // puede arrastrar la forma de venta del anterior.
            state.formaVentaOverrideId = null;
        },
        clearSelectedClient(state) {
            state.selectedClient = null;
            state.clients = [];
            state.formaVentaOverrideId = null;
        },
        setFormaVentaOverride(state, action) {
            state.formaVentaOverrideId = action.payload ?? null;
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(fetchViajanteClientes.pending, (state) => {
                state.loading = true;
            })
            .addCase(fetchViajanteClientes.fulfilled, (state, action) => {
                state.loading = false;
                state.clients = action.payload;
            })
            .addCase(fetchViajanteClientes.rejected, (state) => {
                state.loading = false;
            })
            .addCase(logout, (state) => {
                state.selectedClient = null;
                state.clients = [];
                state.formaVentaOverrideId = null;
            });
    },
});

export const { setSelectedClient, clearSelectedClient, setFormaVentaOverride } = viajanteSlice.actions;
export default viajanteSlice.reducer;
